import i18n from '@/i18n';

if (localStorage.getItem('lang')) {
  i18n.locale = localStorage.getItem('lang');
}

export default {
  AS: i18n.t('Asia'),
  EU: i18n.t('Europe'),
  AF: i18n.t('Africa'),
  NA: i18n.t('North America'),
  SA: i18n.t('South America'),
  AN: i18n.t('Antarctica'),
  OC: i18n.t('Oceania')
}
